export const SESSION_KEY = 'giftly.internal_tracking_data' as const

interface LandingPageTrackingData {
  modelType: 'landing_page'
  modelData: {
    slug: string
    variant: string
  }
}
interface EventTrackingData {
  modelType: 'event'
  modelData: {
    event_id: number
    event_name: string
    event_subtype: string
  }
}
type TrackingData = LandingPageTrackingData | EventTrackingData

export function getInternalOrderGiftTracking () {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as TrackingData | null

    if (!parsed?.modelType) return null
    return {
      internalTrackingData: parsed,
    }
  }
  catch {
    return null
  }
}

export function clearInternalOrderGiftTracking () {
  try {
    sessionStorage.removeItem(SESSION_KEY)
  }
  catch (e) {
    console.error('Failed to clear internal order gift tracking data', e)
  }
}

export function setInternalOrderGiftTracking (data: TrackingData) {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(
      data,
    ))
  }
  catch (e) {
    console.error('Failed to set internal order gift tracking data', e)
  }
}
